export default "__VITE_ASSET__71c909fa__"